import { DirectConnectLenderInvite } from '../../shared/models';
import { Table, TableBody, TableContainer, TableHead, TableRow, TableCell } from '@mui/material';
import { DateUtils, EnumUtils } from '../../shared/utils';

interface LenderInviteListProps {
	invites: DirectConnectLenderInvite[];
	isAcceptedTab: boolean;
}

export const LenderInviteList: React.FC<LenderInviteListProps> = ({ invites, isAcceptedTab }) => {
	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Lender</TableCell>
						<TableCell>Lender Type</TableCell>
						<TableCell>Contact</TableCell>
						<TableCell>Created On</TableCell>
						{isAcceptedTab && <TableCell>Borrower Status</TableCell>}
					</TableRow>
				</TableHead>
				<TableBody>
					{invites.map(teaser => {
						return (
							<TableRow key={teaser.guid}>
								<TableCell>{teaser.bankName}</TableCell>
								<TableCell>{EnumUtils.GetTier1BankTypeDescription(teaser.tier1BankType)}</TableCell>
								<TableCell>{teaser.lenderName}</TableCell>
								<TableCell>{DateUtils.FormatStringAsShortDate(teaser.createdOn.toString())}</TableCell>
								{isAcceptedTab && (
									<TableCell>
										{EnumUtils.GetBorrowerRawLeadInterestDescription(teaser.borrowerStatus)}
									</TableCell>
								)}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
